import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from '@/pages/decedent-profile/styles.less';
import Form from '@/pages/decedent-profile/components/Form';
import { TABS } from '@/pages/decedent-profile/constants';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const DecedentProfile = () => {
  const { t } = useTranslation();
  const { tab } = useParams();
  const history = useHistory();

  const handleChange = useCallback((evt, value) => {
    history.push(value);
  }, []);

  return (
    <div className={styles.page}>
      <Typography variant="h4" className={styles.pageHeader}>
        {t("Decedent's profile")}
      </Typography>
      <Tabs
        className={styles.pageTabs}
        value={tab}
        onChange={handleChange}
        aria-label="profile tabs"
        variant="fullWidth"
      >
        <Tab value={TABS.MAIN} label={t('Main info')} />
        <Tab value={TABS.RESIDENCE} label={t('Residence')} />
        <Tab value={TABS.MARITAL} label={t('Marital status')} />
        <Tab value={TABS.DEPENDANTS} label={t('Dependants')} />
        <Tab value={TABS.DOCS} label={t('Documentation')} />
      </Tabs>
      <Form tab={tab} />
    </div>
  );
};

export default DecedentProfile;
